import React from 'react';
import { PropInfo, CodeExample, TableProps } from '@cimpress/react-components';
import TableCode from '!raw-loader!./table.jsx';
import TableDemo from './table.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const TableDocs = () => {
  const tableProps: PropInfo<TableProps>[] = [
    {
      name: 'isCondensed',
      type: 'boolean',
      default: 'false',
      description: 'Toggles the condensed styling for the table.',
    },
    {
      name: 'isBordered',
      type: 'boolean',
      default: 'false',
      description: 'Adds a border between columns',
    },
    {
      name: 'hasHover',
      type: 'boolean',
      default: 'false',
      description: 'Adds background color change on hovering over a row',
    },
    {
      name: 'sortedBy',
      type: '{key: string, desc: boolean}',
      default: 'undefined',
      description: 'Determines what sort indicator to show in column header',
    },
    {
      name: 'onSortingRequested',
      type: '(newSortKey:{key,desc}',
      default: 'undefined',
      description: 'Callback to the newly requested sorting order',
    },
    {
      name: 'noDataText',
      type: 'string',
      default: "''",
      description: 'Text to show under the robot if no data is present',
    },
    {
      name: 'data',
      type: 'array',
      default: '',
      description: 'Tabular data to show',
    },
    {
      name: 'columns',
      type: 'array<Header,accessor,Cell,sortable>',
      default: '',
      description: 'Column definition',
    },
    {
      name: 'pageSize',
      type: 'number',
      default: 'null',
      description: 'Page size. By default pagination is disabled.',
    },
    {
      name: 'paginationPosition',
      type: 'topRight,bottomRight',
      default: 'bottomRight',
      description: 'Pagination position',
    },
  ];

  return (
    <ComponentDoc name="Table" propInfos={tableProps}>
      <TableDemo />
      <CodeExample code={TableCode} />
    </ComponentDoc>
  );
};

export default TableDocs;
